<form class="update-link-panel" [formGroup]="form" (ngSubmit)="saveChanges()">
    <div class="link-options">
        <div class="link-option">
            <div class="label" trans>Password Protect</div>
            <div class="content">
                <mat-checkbox color="primary" [formControl]="passwordVisible" trans>Require password:</mat-checkbox>
                <ng-container *ngIf="passwordVisible.value">
                    <div class="input-container password-input-container">
                        <input type="password" formControlName="password" placeholder="Enter new password..." trans-placeholder>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>

    <button type="button" (click)="toggleOptionsPanel()" mat-button trans>Cancel</button>

    <button type="submit" class="update-button" mat-raised-button color="primary" [disabled]="loading$ | async">
        {{ ((link$ | async) ? 'Update Link' : 'Create Link') | trans }}
    </button>
</form>